import { Button, Box, Typography, Grid } from "@mui/material";
import FocusAreas from "../FocusAreas";
import pic1 from "../../images/D3.png";
import pic2 from "../../images/D4.png";
import { useMediaQuery, useTheme } from "@mui/material";
import ReportsAccess from "../Reports";
import OngoingProjects from "../OngoingProjects";
import Footer from "../About/Footer";
import { useState } from "react";
import Form from "../Form";
const modernFont = "'Montserrat', sans-serif";
const darkNavy = "#001a33";
const accentCyan = "#33ccff";
const accentPurple = "#5a4bce";
export default function ResearchSection() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [openPartner, setOpenPartner] = useState(false);
  const [openConnect, setOpenConnect] = useState(false);

  const handlePartnerOpen = () => setOpenPartner(true);
  const handlePartnerClose = () => setOpenPartner(false);

  const handleConnectOpen = () => setOpenConnect(true);
  const handleConnectClose = () => setOpenConnect(false);

  const handleClose = () => {
    if (openPartner) handlePartnerClose();
    if (openConnect) handleConnectClose();
  };

  return (
    <>
      <Box sx={{ width: "100%", background: "#fff" }}>
        <Box
          sx={{
            width: "97%",
            mx: "auto",
            px: 2,
            py: { xs: 6, md: 8 },
            background: "#fff",
            height: "100%",
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
            <Box>
              {/* Primary Style Button */}
              <Button
                variant="contained"
                style={{
                  height: "50px",
                  padding: "0 35px",
                  color: "#fff",
                  fontWeight: "700",
                  backgroundColor: accentPurple,
                  borderRadius: "8px",
                  textTransform: "none",
                  fontSize: "16px",
                  fontFamily: modernFont,
                  boxShadow: "0 10px 20px rgba(90, 75, 206, 0.25)",
                  marginBottom: "24px" 
                }}
              >
                Explore More
              </Button>

              <Typography
                variant="h3"
                sx={{
                  color: "#1E1B4B",
                  fontWeight: "800", 
                  fontFamily: modernFont, 
                  lineHeight: 1.2,
                  mb: 2
                }}
              >
                Markoknow Research & <br /> Development (R&D)
              </Typography>

              <Typography
                variant="body1"
                sx={{ 
                  color: "#64748b",
                  maxWidth: "500px", 
                  fontFamily: modernFont, 
                  fontWeight: 500,
                  lineHeight: 1.6,
                  mb: 4 
                }}
              >
                Enhancing innovation through major efforts in Technology,
                Data, Robotics and AI/ML.
              </Typography>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
                <Button
                  variant="contained"
                  onClick={handlePartnerOpen}
                  style={{
                    height: "50px",
                    padding: "0 35px",
                    color: "#fff",
                    fontWeight: "700",
                    backgroundColor: "#1E1B4B", 
                    borderRadius: "8px",
                    textTransform: "none",
                    fontSize: "16px",
                    fontFamily: modernFont,
                    boxShadow: "0 10px 20px rgba(30, 27, 75, 0.2)"
                  }}
                >
                  Partner Us
                </Button>

                <Button
                  variant="outlined"
                  onClick={handleConnectOpen}
                  sx={{
                    height: "50px",
                    px: "35px",
                    borderColor: "#1E1B4B",
                    color: "#1E1B4B",
                    fontWeight: "700",
                    borderRadius: "8px",
                    textTransform: "none",
                    fontSize: "16px",
                    fontFamily: modernFont,
                    borderWidth: "2px",
                    "&:hover": {
                      borderWidth: "2px",
                      backgroundColor: "#1E1B4B",
                      color: "white",
                    },
                  }}
                >
                  Connect with Us
                </Button>
              </Box>
            </Box>
          </Grid>

            <Grid item xs={12} md={6} container justifyContent="center">
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "nowrap", // Prevents stacking on mobile
                  gap: "10px", // Adjusts spacing between images
                  alignItems: "flex-start", // Align images properly
                }}
              >
                {[pic1, pic2].map((pic, index) => (
                  <Box
                    key={index}
                    sx={{
                      position: "relative",
                      width: isMobile ? 180 : 250, // Reduce width on mobile
                      height: isMobile ? 300 : 400, // Reduce height on mobile
                      borderRadius: 2,
                      overflow: "hidden",
                      marginTop:
                        index === 1 ? (isMobile ? "-10px" : "-20px") : "0px", // Adjust offset slightly on mobile
                    }}
                  >
                    <img
                      src={pic}
                      alt={`Research image ${index + 1}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                ))}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <FocusAreas />
      <ReportsAccess />
      <OngoingProjects />
      <Footer />
    </>
  );
}
